'use client';

import { AuthProvider } from "../lib/auth/AuthContext";
import { CookieConsent } from "../components/CookieConsent";

export function ClientLayout({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-white">
        {children}
        <CookieConsent />
      </div>
    </AuthProvider>
  );
}